import React, { useEffect, useState } from "react";
import { Button, Form, FormLabel } from "react-bootstrap";
import { FormControl, InputGroup } from "react-bootstrap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./modal.css";
import TableComponent from "../../../../components/tableComponent/TableComponent";
import ExcelJS from "exceljs";

import {
  AccordionDetails,
  AccordionSummary,
  Typography,
  Accordion,
  FormGroup,
  Tooltip,
} from "@mui/material";
import { SelectAll } from "@mui/icons-material";
import * as Yup from "yup";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";

import DeleteConfirmationModal from "../../../../components/common/DeleteConfirmationModal";

import { useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  addLotSeriesRequest,
  deleteLotSeriesRequest,
  fetchBuyerGroups,
  fetchCategoryRequest,
  fetchGradeRequest,
  fetchKutchaCatalogueRequest,
  fetchLotSeriesByIdRequest,
  fetchLotSeriesRequest,
  fetchMarkRequest,
  fetchMarkTypeRequest,
  fetchSaleNumbersRequest,
  fetchSessionTypeRequest,
  fetchStatusRequest,
  getSaleNoRequest,
  teaTypeAction,
  updateLotSeriesRequest,
} from "../../../../store/actions";
import { useDispatch } from "react-redux";
// import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
// import KutchaCataloguePDF from "../KutchaCataloguePDF";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "react-toastify/dist/ReactToastify.css";
import axiosMain from "../../../../http/axios/axios_main";
import CustomToast from "../../../../components/Toast";
import { useAuctionDetail } from "../../../../components/common/AunctioneerDeteailProvider";
import { useLoader } from "../../../../components/common/Loder/Loder";
import UploadSellerChargesForm from "./uploadSellerCharges";
import { ExportPDF } from "../../../../components/common/DownloadTable";
import axios from "axios";
import PrintableTable from "../../../../components/common/PrintableTable";

const createvalidationSchema = Yup.object().shape({
  markId: Yup.number()
    .min(1, "Please select Mark")
    .required("Mark is required"),
  // if(isEdit===true)
  // {
  status: Yup.number()
    .min(1, "Please select Status")
    .required("Status is required"),
  // }

  // refNo: Yup.string()
  //   .required("Please enter Reference No")
  //   .test('len', 'Maximum length of Reference No Should be 20', val => val && val.toString().length < 20),
  refNo: Yup.string()
    .required("Please enter Reference No")
    .max(20, "Please use only 20 max. alphanumeric characters (A-Z, a-z, 0-9)")
    .matches(
      /^[a-zA-Z0-9]*$/,
      "Reference No should not contain special characters"
    )
    .test(
      "len",
      "Please use only 20 max. alphanumeric characters (A-Z, a-z, 0-9)",
      (val) => val && val.toString().length <= 20
    ),

  //   // .min(1, "Please select Status")
  //   // .required("Please enter PILS")
  //   .test('len', 'Maximum length of PILS Should be 20', val => val && val.toString().length > 20),
  // damageClaims: Yup.number()
  //   // .min(1, "Please select Status")
  //   // .required("Please enter Damage Claims")
  //   .test('len', 'Maximum length of Damage Claims Should be 20', val => val && val.toString().length <= 20),
  sellerChestageAllowance: Yup.string()
    .nullable()
    .notRequired()
    .notRequired()
    .test(
      "is-numeric",
      "Seller Chestage should be Positive Numeric values (0-9) allowed",
      (val) => {
        if (!val) return true;
        return /^\d*\.?\d*$/.test(val); // Checks if the value contains only numeric characters and an optional decimal point
      }
    )
    .test(
      "len",
      "Maximum length of Seller Chestage Allowance should be 20",
      (val) => {
        if (!val) return true;
        const numericLength = val.replace(".", "").length;
        return numericLength <= 20;
      }
    )
    .test("decimals", "Only 2 decimal places are allowed", (val) => {
      if (!val) return true;
      const decimalPart = val.split(".")[1];
      return !decimalPart || decimalPart.length <= 2;
    }),
  freightCharges: Yup.string()
    .nullable()
    .notRequired()
    .notRequired()
    .test(
      "is-numeric",
      "Freight Charges should be Positive Numeric values (0-9) allowed",
      (val) => {
        if (!val) return true;
        return /^\d*\.?\d*$/.test(val); // Checks if the value contains only numeric characters and an optional decimal point
      }
    )
    .test(
      "len",
      "Maximum length of Freight Charges Allowance should be 20",
      (val) => {
        if (!val) return true;
        const numericLength = val.replace(".", "").length;
        return numericLength <= 20;
      }
    )
    .test("decimals", "Only 2 decimal places are allowed", (val) => {
      if (!val) return true;
      const decimalPart = val.split(".")[1];
      return !decimalPart || decimalPart.length <= 2;
    }),
  withdrawnCharges: Yup.string()
    .nullable()
    .notRequired()
    .notRequired()
    .test(
      "is-numeric",
      "Withdrawn Charges (Excluding  taxes) should be Positive Numeric values (0-9) allowed",
      (val) => {
        if (!val) return true;
        return /^\d*\.?\d*$/.test(val); // Checks if the value contains only numeric characters and an optional decimal point
      }
    )
    .test(
      "len",
      "Maximum length of Withdrawn Charges (Excluding  taxes) Allowance should be 20",
      (val) => {
        if (!val) return true;
        const numericLength = val.replace(".", "").length;
        return numericLength <= 20;
      }
    )
    .test("decimals", "Only 2 decimal places are allowed", (val) => {
      if (!val) return true;
      const decimalPart = val.split(".")[1];
      return !decimalPart || decimalPart.length <= 2;
    }),

  pils: Yup.string()
    .nullable()
    .notRequired()
    .notRequired()
    .test(
      "is-numeric",
      "PILS should be Positive Numeric values (0-9) allowed",
      (val) => {
        if (!val) return true;
        return /^\d*\.?\d*$/.test(val); // Checks if the value contains only numeric characters and an optional decimal point
      }
    )
    .test("len", "Maximum length of PILS Allowance should be 20", (val) => {
      if (!val) return true;
      const numericLength = val.replace(".", "").length;
      return numericLength <= 20;
    })
    .test("decimals", "Only 2 decimal places are allowed", (val) => {
      if (!val) return true;
      const decimalPart = val.split(".")[1];
      return !decimalPart || decimalPart.length <= 2;
    }),
  damageClaims: Yup.string()
    .nullable()
    .notRequired()
    .notRequired()
    .test(
      "is-numeric",
      "Damage Claims should be Positive Numeric values (0-9) allowed",
      (val) => {
        if (!val) return true;
        return /^\d*\.?\d*$/.test(val); // Checks if the value contains only numeric characters and an optional decimal point
      }
    )
    .test(
      "len",
      "Maximum length of Damage Claims Allowance should be 20",
      (val) => {
        if (!val) return true;
        const numericLength = val.replace(".", "").length;
        return numericLength <= 20;
      }
    )
    .test("decimals", "Only 2 decimal places are allowed", (val) => {
      if (!val) return true;
      const decimalPart = val.split(".")[1];
      return !decimalPart || decimalPart.length <= 2;
    }),
  // sellerChestageAllowance: Yup.number()
  // .nullable()
  // .notRequired()
  // .matches(/^\d{0,18}(\.\d{0,2})?$/, 'Maximum length of Seller Chestage Allowance should be 20, with up to 2 decimal places.')
  // .test('len', 'Maximum length of Seller Chestage Allowance should be 20', val => {
  //   if (!val) return true;
  //   const valStr = val.toString();
  //   const numericLength = valStr.replace('.', '').length;
  //   return numericLength <= 20;
  // })
  // .test('decimals', 'Only 2 decimal places are allowed', val => {
  //   if (!val) return true;
  //   const decimalPart = val.toString().split('.')[1];
  //   return !decimalPart || decimalPart.length <= 2;
  // }),

  // freightCharges: Yup.number()
  //   // .min(1, "Please select Status")
  //   // .required("Please enter Freight Charges")
  //   .test('len', 'Maximum length of Freight Charges Should be 20', val => val && val.toString().length <= 20),

  // // sptfRecover: Yup.number()
  // //   // .min(1, "Please select Status")
  // //   .required("Please enter SPTF Recovery")
  // //   .test('len', 'Maximum length of SPTF Recovery Should be 20', val => val && val.toString().length <= 20),

  // withdrawnCharges: Yup.number()
  //   // .min(1, "Please select Status")
  //   //.required("Please enter Withdrawn Charges (Excluding  taxes) Recovery")
  //   .test('len', 'Maximum length of Withdrawn Charges (Excluding  taxes) Recovery Should be 20', val => val && val.toString().length <= 20),

  remarks: Yup.string()
    .matches(
      /^[a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>_-]{1,1000}$/,
      "Allows Max. 1000 Alphanumeric and Special Characters (@,*, (,), -, +,/,., Space)"
    )
    .max(1000, "Remarks cannot exceed 1000 characters"),

  // enteredOn: Yup.date()
  //   .required("Please enter Charges Entered On")
});

const createinitialValues = {
  markId: "0",
  status: "1",
  refNo: "",
  pils: "0",
  damageClaims: "0",
  sellerChestageAllowance: "0",
  freightCharges: "0",
  sptfRecover: "0",
  withdrawnCharges: "0",
  damageClaims: "0",
  remarks: "",
  enteredOn: new Date(),
};

const SellerChargesModal = ({ modalRight }) => {
  const {
    auctionCenterId,
    userId,
    auction,
    roleCode,
    auctionTypeMasterCode,
    userCode,
  } = useAuctionDetail();
  const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();
  const [auctionType, setAuctionType] = useState(auction);
  const [auctionTypeCode, setAuctionTypeCode] = useState(auctionTypeMasterCode);
  const baseUrlEngn =
    auction === "ENGLISH" ? "EnglishAuctionSellerCharges" : "SellerCharges";
  const [baseUrlEng, setbaseUrlEng] = useState(baseUrlEngn);

  const dispatch = useDispatch();
  const [lotSeriesDataIds, setLotSeriesData] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [groupCodeListdata, setGroupCodeList] = useState([]);
  const [groupid, setgroupid] = useState(0);
  const [ischecked, setischecked] = useState(true);
  //search
  const [saleNo, setSaleNo] = useState([]);
  const [saleProgramId, setSaleProgramId] = useState(0);
  //for create
  const [createsaleNo, createsetSaleNo] = useState([]);
  const [createsaleProgramId, createsetSaleProgramId] = useState(0);
  const [createMark, createSetMark] = useState("");
  const [tableData, setTableData] = useState([]);
  const lotSeriesData = useSelector(
    (state) => state?.lotSeriesReducer?.data?.responseData
  );

  console.log(lotSeriesData, "lotSeriesData");

  const saleNumber = useSelector(
    (state) => state?.CreatedSaleNo?.saleNumbers?.responseData
  );
  const teaType = useSelector(
    (state) => state?.teaType?.teaTypeList?.responseData
  );

  const abc = useSelector((state) => state.category.loading);
  console.log(abc, "abc");
  const kutchaList = useSelector(
    (state) => state?.kutchaCatalogueReducer?.data?.responseData
  );

  const kutchaListWarning = useSelector(
    (state) => state.kutchaCatalogueReducer.data.message
  );
  const sessionType = useSelector(
    (state) => state?.sessionTypesReducer?.data?.responseData
  );
  console.log(sessionType, "sessionType");

  const statusData = useSelector(
    (state) => state?.category?.statusData?.responseData
  );
  console.log(statusData, ".");
  const markList = useSelector((state) => state?.mark?.data?.responseData);
  const categorystate = useSelector(
    (state) => state?.category?.data?.responseData
  );
  const markType = useSelector((state) => state.mark.markTypeData.responseData);
  const grades = useSelector((state) => state?.grade?.data?.responseData);

  const searchData = useSelector(
    (state) => state?.kutchaCatalogueReducer?.data?.responseData
  );
  console.log(searchData, "categorystate");
  const allLot = [
    {
      id: 1,
      // lotNo: "Lot Number 123",
      // invoiceNo: "INV-2023-001",
      // origin: "Tea Garden",
      teaTypeName: "Black Tea",
      categoryName: "category name",
      seriesFrom: "1000",
      seriesTo: "2000",
    },
    // Add more AWR objects as needed
  ];
  const handleSubmit = (values) => {
    openLoader();
    // Handle form submission here, values object will contain the form data
    const { markId, status } = values;
    const data = {
      markId: parseInt(markId),
      status: parseInt(status),
      userId: userId,
      auctionCenterId: auctionCenterId,
      // role:roleCode
    };
    // dispatch(fetchInvoiceDetailsRequest(data));
    axiosMain
      .post("/preauction/SellerCharges/GetSellerCharges?role=" + roleCode, data)
      .then((res) => {
        setRows(res.data.responseData);
        closeLoader();
      })
      .catch(() => closeLoader());
    // console.log(values);
  };
  // const handleExportPDF = () => {
  //   // You need to replace `rows` with the actual data you want to export
  //   const data = rows;

  //   const pdfBlob = (<KutchaCataloguePDF data={data} />).toBlob();
  //   saveAs(pdfBlob, "kutcha_catalogue.pdf");
  // };

  const handleExportExcel = async () => {
    // Assuming columnName contains the list of objects with "name" and "title"
    let columnsdata = kutcha;
    // columnsdata.pop();
    const columnName = columnsdata;

    // Assuming data contains the list of data objects like [{saleNo: 5}, ...]
    const data = rows.map((ele) => {
      const { SellerChargesID, ...rest } = ele;

      return { ...rest, Status: ele.Status === 1 ? "Not Applied" : "Applied" };
    });
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("SellerCharges");

    // Create a map from name to title for efficient lookup
    const nameToTitleMap = new Map();
    columnName.forEach((column) => {
      nameToTitleMap.set(column.name, column.title);
    });

    // Create the header row based on the columnName array
    const headerRow = worksheet.addRow(
      columnName.map((column) => column.title)
    );
    headerRow.eachCell((cell) => {
      cell.font = {
        bold: true,
        color: { argb: "FFFFFF" },

        // Text color set to white
      };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "183e29" }, // Background color (you can change the color code)
      };
    });
    // Add data rows based on columnName and data
    data.forEach((row) => {
      const rowData = columnName.map((column) => row[column.name]);
      worksheet.addRow(rowData);
    });

    // Automatically adjust column widths based on content
    worksheet.columns.forEach((column, index) => {
      const headerLength = columnName[index].title.length;
      const maxColumnWidth = column.values.reduce((acc, val) => {
        const cellLength = val ? val.toString().length : 0;
        return Math.max(acc, cellLength);
      }, headerLength);
      column.width = maxColumnWidth + 5; // Adding extra width for padding
    });

    const buffer = await workbook.xlsx.writeBuffer();

    // Convert the buffer to a Blob
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Save the Blob as a file
    saveAs(blob, "SellerCharges.xlsx");
  };
  // const handleExportExcel = () => {

  //   let newrows = rows?.map(item => {
  //     const { srNo,prsAuctionSessionId,auctionSessionLotConfiguration,...newdata } = item;
  //     return newdata;
  //   })
  //   // Create a new workbook and worksheet
  //   const workbook = XLSX.utils.book_new();
  //   const worksheet = XLSX.utils.json_to_sheet(newrows);

  //   // Add the worksheet to the workbook
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "BusinessRule");

  //   // Generate Excel file
  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const blob = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });
  //   saveAs(blob, "BusinessRule.xlsx");
  // };
  ///samar
  const groupCodeList = useSelector(
    (state) => state?.groupMaster?.buyerGroups?.data?.responseData
  );
  console.log(groupCodeList, "Gropu datas.......................");

  useEffect(() => {
    setGroupCodeList(groupCodeList);
  }, [groupCodeList]);

  //bind group
  const bindGroupsList = () => {
    axiosMain
      .get("/preauction/GroupMaster/BindGroups?buyerUserId=" + userId)
      .then((response) => {
        // Handle the successful response here
        console.log("Response:", response.data);
        console.log("after update group bind", response.data.responseData);
        setGroupCodeList(response.data.responseData);
        setRows([]);
      })

      .catch((error) => {
        // Handle any errors here
        console.error("Error:", error);
      });
  };

  const handleRemove = () => {
    const requestData = {
      lotNoSeriesID: actionData.edit.lotNoSeriesID,
      updatedBy: userId,
    };

    // Dispatch the deleteLotSeriesRequest action with the provided data
    dispatch(deleteLotSeriesRequest(requestData));
    setOpenDelete(false);
  };
  function generateYearOptions() {
    const currentYear = new Date().getFullYear();
    const options = [];

    for (let i = currentYear; i > currentYear - 7; i--) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }

    return options;
  }
  const validationSchema = Yup.object().shape({
    // markId: Yup.number()
    //   .min(1, "Please select Mark")
    //   .required("Mark is required"),
    // status: Yup.number()
    //   .min(1, "Please select Status")
    //   .required("Status is required"),
  });
  const initialValues = {
    markId: "0",
    status: "0",
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });
  useEffect(() => {
    const seasondata = {
      season: formik?.values?.season?.toString(),
      auctionCenterId: auctionCenterId,
    };
    axiosMain
      // .post(
      //   `/preauction/Common/BindSaleNoBySeason?season=${formik.values.season}`
      // )
      .post(`/preauction/Common/BindSaleNoBySeason`, seasondata)
      .then((res) => setSaleNo(res.data.responseData))
      .catch((err) => CustomToast.error(err));
  }, [formik.values.season]);

  // useEffect(() => {
  //   console.log("api cal");
  //   const saleNo = formik.values.saleNo;
  //   const season = formik.values.season;
  //   console.log(saleNo, season, "sas");
  //   // API endpoint URL
  //   const apiUrl = `/preauction/Common/GetSaleProgramDetailBySaleNo`;

  //   // Data to be sent in the POST request

  //   if (
  //     saleNo !== undefined &&
  //     saleNo !== "" &&
  //     formik.values.season !== "" &&
  //     formik.values.season !== undefined
  //   ) {
  //     // Making the POST request using axiosMain
  //     setSaleProgramId(0);
  //     axiosMain
  //       .post(apiUrl, {
  //         saleNo: parseInt(saleNo),
  //         season: season.toString(),
  //         auctionCenterId: auctionCenterId,
  //       })
  //       .then((response) => {
  //         console.log(
  //           response.data.responseData[0].SaleProgramId,
  //           "saleno sel"
  //         );
  //         setSaleProgramId(response.data.responseData[0].SaleProgramId);
  //       })
  //       .catch((error) => {
  //         // Handle errors here
  //       });
  //   }

  //   // Cleanup function, in case you need to cancel the request
  //   return () => {
  //     // Cancel the request (if necessary) to avoid memory leaks
  //   };
  // }, [formik.values.saleNo, formik.values.season]);

  //for create formik
  const handleDownload = () => {
    let documentName = "SellerCharges.xlsx";

    axiosMain
      .post(
        "/preauction/SellerCharges/DownloadSellerChargesExcel",
        {
          auctionCenterId: auctionCenterId,
          userId: userId,
          markId: parseInt(formik.values.markId),
          status: parseInt(formik.values.status),
        }
        // rows?.map((ele) => {
        //   return { LotNo: ele.LotNo };
        // })
      )
      .then((res) => {
        let documentBytes = res?.data?.responseData[0]?.byteDatas;

        // Decode base64 encoded documentBytes
        const decodedBytes = atob(documentBytes);

        // Create a Blob from the decoded bytes
        const blob = new Blob([
          new Uint8Array([...decodedBytes].map((char) => char.charCodeAt(0))),
        ]);

        // Create an object URL from the Blob
        const blobUrl = URL.createObjectURL(blob);

        // Create a hidden anchor element
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.href = blobUrl;
        anchor.download = documentName;

        // Append anchor to the body
        document.body.appendChild(anchor);

        // Programmatically click the anchor element
        anchor.click();

        // Clean up: remove the anchor and revoke the object URL
        document.body.removeChild(anchor);
        URL.revokeObjectURL(blobUrl);
      })
      .catch((err) => console.log(err));
  };

  const createformik = useFormik({
    initialValues: createinitialValues,

    validationSchema: createvalidationSchema,
    onSubmit: (values) => {
      let url = "";
      let formData = [];
      openLoader();

      const filledFields = [
        values.pils,
        values.damageClaims,
        values.sellerChestageAllowance,
        values.freightCharges,
        values.withdrawnCharges,
      ].filter((value) => value !== "0" && value !== "");
      if (filledFields.length === 0) {
        CustomToast.error("Please enter at least one seller charge.");
        return false;
      }
      if (isEdit === false) {
        formData = {
          MarkId: values.markId,
          ReferenceNo: values.refNo?.toString(),
          PILS: values.pils === "" ? 0 : values.pils,
          DamageClaims: values.damageClaims === "" ? 0 : values.damageClaims,
          SellerChestageAllowance:
            values.sellerChestageAllowance === ""
              ? 0
              : values.sellerChestageAllowance,
          FreightCharges:
            values.freightCharges === "" ? 0 : values.freightCharges,
          SPTFRecovery: values.sptfRecover === "" ? 0 : values.sptfRecover,
          WithdrawnCharges:
            values.withdrawnCharges === "" ? 0 : values.withdrawnCharges,
          Remarks: values.remarks,
          Status: 1,
          isActive: true,
          CreatedBy: userId,
          UpdatedBy: userId,
          ChargesEnteredOn: null,
          CreatedOn: null,
          UpdatedOn: null,
          //MarkCode: markDataList?.filter((ele) => ele.markId === values.markId)[0]?.markCode,
        };
        url = "/preauction/SellerCharges/CreateSellerCharges";
      } else {
        formData = [
          {
            MarkId: values.markId,
            ReferenceNo: values.refNo?.toString(),
            PILS: values.pils === "" ? 0 : values.pils,
            DamageClaims: values.damageClaims === "" ? 0 : values.damageClaims,
            SellerChestageAllowance:
              values.sellerChestageAllowance === ""
                ? 0
                : values.sellerChestageAllowance,
            FreightCharges:
              values.freightCharges === "" ? 0 : values.freightCharges,
            SPTFRecovery: values.sptfRecover === "" ? 0 : values.sptfRecover,
            WithdrawnCharges:
              values.withdrawnCharges === "" ? 0 : values.withdrawnCharges,
            Remarks: values.remarks,
            Status: values.status,
            isActive: true,
            CreatedBy: userId,
            UpdatedBy: userId,
            MarkCode: markDataList?.filter(
              (ele) => ele.markId === values.markId
            )[0]?.markCode,
            auctionCenterId
          },
        ];
        url =
          "/preauction/SellerCharges/UploadSellerCharges?flag=update&validateAction=submit";
      }

      axiosMain
        .post(url, formData)
        .then((response) => {
          // Handle the successful response here
          console.log("Response:", response.data);
          if (response.data.statusCode == 200) {
            CustomToast.success(response.data.message);

            createformik.resetForm();
            setExpandedTab("panel1");
            setIsEdit(false);
            createsetSaleProgramId(0);
            formik.handleSubmit();
          } else CustomToast.error(response.data.message);

          closeLoader();
        })
        .catch((error) => {
          closeLoader();

          // Handle any errors here
          console.error("Error:", error);
        });

      //console.log(formData, kutchaListWarning, kutchaList, "tabval"); // Handle form submission here
    },
  });
  const convertedittddmmformat = (dateStr) => {
    const date = new Date(dateStr);
    debugger;
    const [dd1, mm1, yyyy1] = [
      date.getDate().toString().padStart(2, "0"),
      (date.getMonth() + 1).toString().padStart(2, "0"),
      date.getFullYear(),
    ];

    const [time1, period1] = date?.toLocaleTimeString("en-US")?.split(" ");

    const [hh1, min1, sec1] = time1
      ?.split(":")
      ?.map((ele) => (ele.toString()?.length === 1 ? `0${ele}` : ele));
    return `${dd1}-${mm1}-${yyyy1} ${hh1}:${min1}:${sec1} ${period1}`;
  };
  const hasPermission = modalRight.some((right) =>
    ["3", "2", "78"].includes(right)
  );

  const ActionArea = (row) => {
    function handleAction(action) {
      const { markId, status } = values;
      const data = {
        markId: parseInt(markId),
        SellerChargesID: parseInt(row?.data?.SellerChargesID),
        userId: userId,
        auctionCenterId: auctionCenterId,
        // role:roleCode
      };
      switch (action) {
        case "view": {
          setExpandedTab("panel2");
          const lotNo = row.data.prsAuctionSessionId;
          openLoader();
          axiosMain
            .post("/preauction/SellerCharges/GetSellerChargesById", data)
            .then((response) => {
              // Handle the successful response here
              createformik.setFieldValue(
                "markId",
                response.data.responseData[0].MarkId
              );
              // createformik.setFieldValue(
              //   "status",
              //   response.data.responseData[0].Status === 0 ? "All" : response.data.responseData[0].Status === 1 ? "Not Applied" : "Applied"
              // );
              createformik.setFieldValue(
                "status",
                response.data.responseData[0].Status
              );
              createformik.setFieldValue(
                "pils",
                response.data.responseData[0].PILS
              );
              createformik.setFieldValue(
                "refNo",
                response.data.responseData[0].ReferenceNo
              );
              createformik.setFieldValue(
                "damageClaims",
                response.data.responseData[0].DamageClaims
              );
              createformik.setFieldValue(
                "sellerChestageAllowance",
                response.data.responseData[0].SellerChestageAllowance
              );

              createformik.setFieldValue(
                "freightCharges",
                response.data.responseData[0].FreightCharges
              );
              // createformik.setFieldValue(
              //   "sptfRecover",
              //   response.data.responseData[0].SPTFRecovery
              // );

              createformik.setFieldValue(
                "withdrawnCharges",
                response.data.responseData[0].WithdrawnCharges
              );
              createformik.setFieldValue(
                "remarks",
                response.data.responseData[0].Remarks
              );
              createformik.setFieldValue(
                "enteredOn",
                convertedittddmmformat(
                  response.data.responseData[0].ChargesEnteredOn
                )
                // response.data.responseData[0].ChargesEnteredOn?.split("T")[0]
              );
              closeLoader();
            })
            .catch((error) => {
              closeLoader();
              // Handle any errors here
              console.error("Error:", error);
            });
          setIsDisabled(true);
          setIsDisabled1(true);
          break;
        }
        case "edit": {
          setExpandedTab("panel2");
          setIsDisabled(false);
          setIsDisabled1(true);
          const lotNo = row.data.prsAuctionSessionId;

          setgroupid(lotNo);
          openLoader();
          axiosMain
            .post("/preauction/SellerCharges/GetSellerChargesById", data)
            .then((response) => {
              // Handle the successful response here
              console.log("EditResponse:", response.data.responseData[0]);
              createsetSaleProgramId(
                response.data.responseData[0].SellerChargesID
              );

              // createformik.setFieldValue(
              //   "auctionSession",
              //   response.data.responseData[0].auctionSessionLotConfiguration
              // );
              //   {
              //     "MarkId": 100,
              //     "MarkCode": "TESTMARCH",
              //     "PILS": 0,
              //     "SellerChestageAllowance": 100,
              //     "SPTFRecovery": 0,
              //     "DamageClaims": 20,
              //     "WithdrawnCharges": 200,
              //     "FreightCharges": 15,
              //     "Remarks": null,
              //     "ReferenceNo": "INVOICE022024",
              //     "ChargesEnteredOn": "2024-06-27T10:28:44.103",
              //     "Status": 2
              // }
              createformik.setFieldValue(
                "markId",
                response.data.responseData[0].MarkId
              );
              createformik.setFieldValue(
                "status",
                response.data.responseData[0].Status
              );
              createformik.setFieldValue(
                "pils",
                response.data.responseData[0].PILS
              );
              createformik.setFieldValue(
                "refNo",
                response.data.responseData[0].ReferenceNo
              );
              createformik.setFieldValue(
                "damageClaims",
                response.data.responseData[0].DamageClaims
              );
              createformik.setFieldValue(
                "sellerChestageAllowance",
                response.data.responseData[0].SellerChestageAllowance
              );

              createformik.setFieldValue(
                "freightCharges",
                response.data.responseData[0].FreightCharges
              );
              // createformik.setFieldValue(
              //   "sptfRecover",
              //   response.data.responseData[0].SPTFRecovery
              // );

              createformik.setFieldValue(
                "withdrawnCharges",
                response.data.responseData[0].WithdrawnCharges
              );
              createformik.setFieldValue(
                "remarks",
                response.data.responseData[0].Remarks
              );
              createformik.setFieldValue(
                "enteredOn",
                convertedittddmmformat(
                  response.data.responseData[0].ChargesEnteredOn
                )
                // response.data.responseData[0].ChargesEnteredOn?.split("T")[0]
              );
              closeLoader();
            })
            .catch((error) => {
              closeLoader();
              // Handle any errors here
              console.error("Error:", error);
            });
          // setSelectedSaleProgram(saleProgramDetail);

          setIsEdit(true);
        }
        case "delete": {
          createSetMark(row?.data?.MarkCode);
          createsetSaleProgramId(row?.data?.SellerChargesID);
        }
        default:
          return "no data";
      }
    }

    // if (!saleProgramList || !saleNumber) {
    //   return (
    //     <div>
    //       <NoData />
    //     </div>
    //   ); // Show a message when no data is available
    // }
    return (
      <>
        {row.data.Status === 1 ? (
          <>
            <div className="Action">
              {modalRight?.includes("3") && (
                <span onClick={() => handleAction("view")}>
                  <VisibilityIcon />
                </span>
              )}
              {modalRight?.includes("2") && (
                <span onClick={() => handleAction("edit")}>
                  <EditIcon />
                </span>
              )}
              {modalRight?.includes("78") && (
                <span
                  onClick={() => {
                    setOpenDelete(true);
                    handleAction("delete");
                    // setActionData({ ...actionData, edit: row.data });
                  }}
                >
                  <DeleteIcon />
                </span>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="Action">
              {modalRight?.includes("3") && (
                <span onClick={() => handleAction("view")}>
                  <VisibilityIcon />
                </span>
              )}
            </div>
          </>
        )}
      </>
    );
  };
  const invoices = hasPermission
    ? [
        {
          name: "SrNo",
          title: "Sr. No.",
        },
        {
          name: "MarkCode",
          title: "Mark Code",
        },
        {
          name: "PILS",
          title: "PILS",
        },
        {
          name: "SellerChestageAllowance",
          title: "Seller Chestage Allowance",
        },
        {
          name: "SPTFRecovery",
          title: "SPTF Recovery",
        },
        {
          title: "Damage Claims",
          name: "DamageClaims",
        },
        {
          name: "WithdrawnCharges",
          title: "Withdrawn Charges (Excluding Taxes)",
        },
        {
          name: "FreightCharges",
          title: "Freight Charges",
        },
        {
          name: "Remarks",
          title: "Remarks",
        },
        {
          name: "ReferenceNo",
          title: "Reference No.",
        },
        {
          name: "ChargesEnteredOn",
          title: "Charges Entered On",

          getCellValue: ({ ...row }) =>
            convertedittddmmformat(row?.ChargesEnteredOn),
        },
        {
          name: "Status",
          title: "Status",

          getCellValue: ({ ...row }) => {
            switch (row.Status) {
              case 1: {
                return "Not Applied";
              }
              case 2: {
                return "Applied";
              }
              default: {
                return "All";
              }
            }
          },
        },
        {
          name: "action",
          title: "Action",
          getCellValue: ({ ...row }) => <ActionArea data={row} />,
        },
      ]
    : [
        {
          name: "SrNo",
          title: "Sr. No.",
        },
        {
          name: "MarkCode",
          title: "Mark Code",
        },
        {
          name: "PILS",
          title: "PILS",
        },
        {
          name: "SellerChestageAllowance",
          title: "Seller Chestage Allowance",
        },
        {
          name: "SPTFRecovery",
          title: "SPTF Recovery",
        },
        {
          title: "Damage Claims",
          name: "DamageClaims",
        },
        {
          name: "WithdrawnCharges",
          title: "Withdrawn Charges (Excluding Taxes)",
        },
        {
          name: "FreightCharges",
          title: "Freight Charges",
        },
        {
          name: "Remarks",
          title: "Remarks",
        },
        {
          name: "ReferenceNo",
          title: "Reference No.",
        },
        {
          name: "ChargesEnteredOn",
          title: "Charges Entered On",

          getCellValue: ({ ...row }) =>
            convertedittddmmformat(row?.ChargesEnteredOn),
        },
        {
          name: "Status",
          title: "Status",

          getCellValue: ({ ...row }) => {
            switch (row.Status) {
              case 1: {
                return "Not Applied";
              }
              case 2: {
                return "Applied";
              }
              default: {
                return "All";
              }
            }
          },
        },
        // {
        //   name: "action",
        //   title: "Action",
        //   getCellValue: ({ ...row }) => <ActionArea data={row} />,
        // },
      ];
  //Createa time
  // useEffect(() => {
  //   const seasondata = {
  //     season: createformik.values.season.toString(),
  //     auctionCenterId: auctionCenterId,
  //   };
  //   axiosMain
  //     .post(`/preauction/Common/BindSaleNoBySeason`, seasondata)
  //     .then((res) => createsetSaleNo(res.data.responseData))
  //     .catch((err) => CustomToast.error(err));
  // }, [createformik.values.season]);

  // useEffect(() => {
  //   console.log("api cal");
  //   const saleNo = createformik.values.saleNo;
  //   const season = createformik.values.season;
  //   console.log(saleNo, season, "sas");
  //   // API endpoint URL
  //   const apiUrl = `/preauction/Common/GetSaleProgramDetailBySaleNo`;

  //   // Data to be sent in the POST request

  //   if (
  //     saleNo !== undefined &&
  //     saleNo !== "" &&
  //     createformik.values.season !== "" &&
  //     createformik.values.season !== undefined
  //   ) {
  //     // Making the POST request using axiosMain
  //     createsetSaleProgramId(0);
  //     axiosMain
  //       .post(apiUrl, {
  //         saleNo: parseInt(saleNo),
  //         season: season.toString(),
  //         auctionCenterId: auctionCenterId,
  //       })
  //       .then((response) => {
  //         console.log(
  //           response.data.responseData[0].SaleProgramId,
  //           "saleno sel"
  //         );
  //         createsetSaleProgramId(response.data.responseData[0].SaleProgramId);
  //       })
  //       .catch((error) => {
  //         // Handle errors here
  //       });
  //   }

  //   // Cleanup function, in case you need to cancel the request
  //   return () => {
  //     // Cancel the request (if necessary) to avoid memory leaks
  //   };
  // }, [createformik.values.saleNo, createformik.values.season]);
  // useEffect(() => {
  //   // Check for responseData and show toast notification if it's null
  //   if (kutchaList === null) {
  //     CustomToast.warning(kutchaListWarning, {
  //       position: CustomToast.POSITION.TOP_CENTER,
  //       autoClose: 3000,
  //     });
  //   }
  // }, [kutchaList, kutchaListWarning]);
  useEffect(() => {
    if (
      createformik.values.markId != 0 ||
      createformik.values.markId !== null
    ) {
      axiosMain
        .post("/preauction/SellerCharges/GetSPTFRecoveryAmount", {
          MarkId: parseInt(createformik.values.markId),
          auctionCenterId: auctionCenterId,
        })
        .then((response) => {
          createformik.setFieldValue(
            "sptfRecover",
            response.data?.responseData[0]?.SPTFRecoveryAmount
          );
        })
        .catch((error) => {
          // Handle errors here
        });
    }
  }, [createformik.values.markId]);
  console.log(kutchaListWarning, "mss");
  // Check for responseData and show toast notification if it's null

  const [sellsNo, setSellNo] = useState(1);

  const [expandedTab, setExpandedTab] = useState("panel1");
  const [rows, setRows] = useState([]);
  // const [year, setYear] = useState("2023");
  const [sessionTypes, setSessionType] = useState(sessionType); // If using React state hooks

  const [teaTypeList, setTeaTeatypeList] = useState([]);
  const [kutchaData, setTeakutchaData] = useState([]);
  const [gradesList, setGradesList] = useState([]);
  const [markDataList, setMarkDataList] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectAllRow, setSelectAllRow] = useState(false);
  const [mark, setmark] = useState([]);
  const [categoryList, setcategory] = useState([]);
  const [actionData, setActionData] = useState({
    view: {},
    edit: {},
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisabled1, setIsDisabled1] = useState(false);
  const { handleChange, handleBlur, values, touched, errors } = formik;

  console.log(sessionTypes, "sessionTypess");
  // {
  //   id: 1,
  //   // lotNo: "Lot Number 123",
  //   // invoiceNo: "INV-2023-001",
  //   // origin: "Tea Garden",
  //   teaTypeName: "Black Tea",
  //   category: "category name",
  //   seriesFrom: "1000",
  //   seriesTo: "2000",
  // },

  const kutcha = [
    {
      name: "SrNo",
      title: "Sr. No.",
    },
    {
      name: "MarkCode",
      title: "Mark Code",
    },
    {
      name: "PILS",
      title: "PILS",
    },
    {
      name: "SellerChestageAllowance",
      title: "Seller Chestage Allowance",
    },
    {
      name: "SPTFRecovery",
      title: "SPTF Recovery",
    },
    {
      title: "Damage Claims",
      name: "DamageClaims",
    },
    {
      name: "WithdrawnCharges",
      title: "Withdrawn Charges (Excluding Taxes)",
    },
    {
      name: "FreightCharges",
      title: "Freight Charges",
    },
    {
      name: "Remarks",
      title: "Remarks",
    },
    {
      name: "ReferenceNo",
      title: "Reference No.",
    },
    {
      name: "ChargesEnteredOn",
      title: "Charges Entered On",

      getCellValue: ({ ...row }) =>
        convertedittddmmformat(row?.ChargesEnteredOn), //row.ChargesEnteredOn?.split("T")?.at(0),
    },
    {
      name: "Status",
      title: "Status",

      getCellValue: ({ ...row }) => {
        switch (row.Status) {
          case 1: {
            return "Not Applied";
          }
          case 2: {
            return "Applied";
          }
          default: {
            return "All";
          }
        }
      },
    },
  ];

  console.log(rows, "rows");

  // useEffect(() => {
  //   if (teaTypeList && teaTypeList.length > 0) {
  //     formik.setFieldValue("teaType", teaTypeList[0]?.teaTypeId);
  //   }
  // }, [teaTypeList, formik]);

  const handleAccordionChange = (panel) => (_, isExpanded) => {
    setExpandedTab(isExpanded ? panel : null);
    //setLotSeriesData([]);
    setIsEdit(false);
    createformik.setFieldValue("season", "");
    createformik.setFieldValue("saleNo", "");
    createformik.resetForm();
    setIsDisabled(false);
    setIsDisabled1(false);
    if (panel === "panel3") {
      setTableData([]);
    }

    // if(panel==="panel1")
    // {
    //   formik.resetForm()
    // formik.setFieldValue("groupCode", "")
    // formik.setFieldValue("groupName", "")
    // setRows([]);
    // }
  };

  useEffect(() => {
    axiosMain
      .post(
        "/preauction/Common/BindMark?auctionCenterId=" + auctionCenterId,
        {}
      )
      .then((res) => {
        if (res.data.statusCode === 200) {
          setMarkDataList(res.data.responseData);
        } else {
          setMarkDataList([]);
        }
      });
  }, []);
  const AWRCheckBox = (data) => {
    const handleChange = (e) => {
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === data.data.id ? { ...row, checked: e.target.checked } : row
        )
      );

      const allChecked = rows.every((row) => row.checked);
      setSelectAllRow(allChecked);
    };
    useEffect(() => {
      const allChecked = rows.every((row) => row.checked);
      setSelectAllRow(allChecked);
    }, [rows]);

    return (
      <>
        <Form.Check
          type="checkbox"
          id="custom-switch"
          checked={data.data.checked}
          onChange={handleChange}
        />
      </>
    );
  };

  const [mm, dd, yy] = new Date()
    ?.toLocaleDateString()
    ?.split("/")
    ?.map((ele) => (ele.toString()?.length === 1 ? `0${ele}` : ele));
  const [time, period] = new Date()?.toLocaleTimeString()?.split(" ");

  const [hh, min, sec] = time
    ?.split(":")
    ?.map((ele) => (ele.toString()?.length === 1 ? `0${ele}` : ele));

  const now = new Date();
  let hours = now.getHours();
  const minutes = now.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  // useEffect(() => {
  //   setRows(lotSeriesData);
  // }, [lotSeriesData]);
  // console.log(rows,"rows")
  return (
    <>
      <div>
        <DeleteConfirmationModal
          show={openDelete}
          title={
            "Are you sure, you want to delete seller charges for selected Mark Code" +
            createMark +
            "?"
          }
          onDelete={() => {
            openLoader();
            axiosMain
              .post("/preauction/SellerCharges/DeleteSellerCharges", {
                userId: userId,
                SellerChargesID: createsaleProgramId,
                // sessionTypeId: sessionTypeId,
              })
              .then((res) => {
                if (res.data.statusCode === 200) {
                  CustomToast.success(res.data.message);
                  formik.handleSubmit();
                } else {
                  CustomToast.warning(res.data.message);
                  // setRows([]);
                }
                closeLoader();
              })
              .catch((err) => {
                console.log(err);
                closeLoader();
              });

            setOpenDelete(false);
          }}
          onHide={() => setOpenDelete(false)}
        />

        <Accordion
          expanded={expandedTab === "panel1"}
          onChange={handleAccordionChange("panel1")}
          className={`${expandedTab === "panel1" ? "active" : ""}`}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Manage Seller Charges</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-xl-2 col-lg-4 col-md-3">
                  <div className="FormGrup">
                    <label>Mark Code</label>
                    <InputGroup>
                      <Form.Control
                        as="select"
                        name="markId"
                        value={formik.values.markId}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        <option value={0}>All</option>
                        {markDataList?.length > 0
                          ? markDataList?.map((item, index) => (
                              <option value={item.markId} key={index}>
                                {item.markCode}
                              </option>
                            ))
                          : "No Data"}
                      </Form.Control>
                    </InputGroup>
                    {formik.touched.markId && formik.errors.markId && (
                      <div className="error-message text-danger">
                        {formik.errors.markId}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-4">
                  <div className="FormGrup">
                    <label>Status</label>
                    <InputGroup>
                      <Form.Control
                        as="select"
                        name="status"
                        value={formik.values.status}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        <option value={0}>All</option>
                        <option value={1}>Not Applied</option>
                        <option value={2}>Applied</option>
                      </Form.Control>
                    </InputGroup>
                    {formik.touched.status && formik.errors.status && (
                      <div className="error-message text-danger">
                        {formik.errors.status}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-xl-auto mt-2">
                  <div className="BtnGroup">
                    <button className="SubmitBtn" type="submit">
                      Search
                    </button>
                    {modalRight?.includes("6") && (
                      <button
                        type="button"
                        className="SubmitBtn"
                        onClick={handleDownload}
                      >
                        Download Format
                      </button>
                    )}
                    {modalRight?.includes("7") && (
                      <>
                        <Tooltip title="Export as Print">
                          <button
                            type="button"
                            className="Excel"
                            onClick={() =>
                              PrintableTable(
                                invoices?.filter(
                                  (ele) => ele.title !== "Action"
                                ),
                                rows?.length > 0
                                  ? rows.map((ele) => {
                                      let data = {
                                        ...ele,
                                        Status:
                                          ele.Status === 0
                                            ? "All"
                                            : ele.Status === 1
                                            ? "Not Applied"
                                            : ele.Status === 2
                                            ? "Applied"
                                            : "",
                                      };

                                      return data;
                                    })
                                  : []
                              )
                            }
                          >
                            <i className="fa fa-print"></i>
                          </button>
                        </Tooltip>
                        <Tooltip title="Export as Excel">
                          <button
                            type="button"
                            // className="SubmitBtn"
                            className="Excel"
                            onClick={handleExportExcel}
                          >
                            <i className="fa fa-file-excel"></i>
                          </button>
                        </Tooltip>

                        <ExportPDF
                          columns={invoices?.filter(
                            (ele) => ele.title !== "Action"
                          )}
                          data={
                            rows?.length > 0
                              ? rows.map((ele) => {
                                  return {
                                    ...ele,
                                    Status:
                                      ele.Status === 1
                                        ? "Not Applied"
                                        : "Applied",
                                  };
                                })
                              : []
                          }
                          name={"SellerCharges"}
                          auctionType={auction}
                        />
                      </>
                    )}
                    {/* <button className="SubmitBtn" type="submit">
                        <i className="fa fa-refresh"></i>
                      </button> */}
                    <button
                      type="button"
                      className="SubmitBtn"
                      onClick={() => {
                        formik.resetForm();

                        setRows([]);
                      }}
                    >
                      {/* <i className="fa fa-refresh"></i> */}
                      Clear
                    </button>
                  </div>
                </div>
                <div className="col-xl-12 TableBox">
                  <TableComponent
                    columns={invoices}
                    rows={rows?.length > 0 ? rows : []}
                    setRows={setRows}
                    dragdrop={true}
                    module="pre-auction"
                    fixedColumnsOn={false}
                    resizeingCol={false}
                    selectionCol={true}
                    sorting={true}
                  />
                </div>
              </div>
            </form>
          </AccordionDetails>
        </Accordion>
        {/* <ToastContainer position="top-center" autoClose={3000} /> */}
        {modalRight.includes("1") && (
          <Accordion
            expanded={expandedTab === "panel2"}
            onChange={handleAccordionChange("panel2")}
            className={`${expandedTab === "panel2" ? "active" : ""}`}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography>
                {isEdit === true
                  ? "Edit Seller Charges"
                  : isDisabled === true
                  ? "View Seller Charges"
                  : "Create Seller Charges"}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <form onSubmit={createformik.handleSubmit}>
                <div className="row">
                  <div className="col-lg-2">
                    <label>Mark Code</label>
                    <InputGroup>
                      <Form.Control
                        disabled={
                          isEdit === true
                            ? true
                            : isDisabled === true
                            ? true
                            : false
                        }
                        as="select"
                        name="markId"
                        value={createformik.values.markId}
                        onChange={createformik.handleChange}
                        onBlur={createformik.handleBlur}
                      >
                        <option value={0}>All</option>
                        {markDataList?.length > 0
                          ? markDataList?.map((item, index) => (
                              <option value={item.markId} key={index}>
                                {item.markCode}
                              </option>
                            ))
                          : "No Data"}
                      </Form.Control>
                    </InputGroup>
                    {createformik.errors.markId &&
                      createformik.touched.markId && (
                        <div className="error text-danger">
                          {createformik.errors.markId}
                        </div>
                      )}
                  </div>

                  <div className="col-lg-2">
                    <label>Reference No.</label>
                    <InputGroup>
                      <Form.Control
                        disabled={isDisabled}
                        type="text"
                        name="refNo"
                        value={createformik.values.refNo}
                        onChange={createformik.handleChange}
                        onBlur={createformik.handleBlur}
                      />
                    </InputGroup>
                    {createformik.errors.refNo &&
                      createformik.touched.refNo && (
                        <div className="error text-danger">
                          {createformik.errors.refNo}
                        </div>
                      )}
                  </div>
                  <div className="col-lg-2">
                    <label>PILS</label>
                    <InputGroup>
                      <Form.Control
                        // disabled={isDisabled}
                        disabled={
                          isDisabled === true
                            ? true
                            : createformik.values.pils > 0
                            ? false
                            : createformik.values.damageClaims > 0 ||
                              createformik.values.sellerChestageAllowance > 0 ||
                              createformik.values.freightCharges > 0 ||
                              createformik.values.withdrawnCharges > 0
                        }
                        type="text"
                        name="pils"
                        value={createformik.values.pils}
                        onChange={createformik.handleChange}
                        onBlur={createformik.handleBlur}
                      />
                    </InputGroup>
                    {createformik.errors.pils && createformik.touched.pils && (
                      <div className="error text-danger">
                        {createformik.errors.pils}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-2">
                    <label>Damage Claims</label>
                    <InputGroup>
                      <Form.Control
                        // disabled={isDisabled}
                        disabled={
                          isDisabled === true
                            ? true
                            : createformik.values.damageClaims > 0
                            ? false
                            : createformik.values.pils > 0 ||
                              createformik.values.sellerChestageAllowance > 0 ||
                              createformik.values.freightCharges > 0 ||
                              createformik.values.withdrawnCharges > 0
                        }
                        type="text"
                        name="damageClaims"
                        value={createformik.values.damageClaims}
                        onChange={createformik.handleChange}
                        onBlur={createformik.handleBlur}
                      />
                    </InputGroup>
                    {createformik.errors.damageClaims &&
                      createformik.touched.damageClaims && (
                        <div className="error text-danger">
                          {createformik.errors.damageClaims}
                        </div>
                      )}
                  </div>
                  <div className="col-lg-2">
                    <label>Seller Chestage Allowance</label>
                    <InputGroup>
                      <Form.Control
                        // disabled={isDisabled}
                        disabled={
                          isDisabled === true
                            ? true
                            : createformik.values.sellerChestageAllowance > 0
                            ? false
                            : createformik.values.damageClaims > 0 ||
                              createformik.values.pils > 0 ||
                              createformik.values.freightCharges > 0 ||
                              createformik.values.withdrawnCharges > 0
                        }
                        type="text"
                        name="sellerChestageAllowance"
                        value={createformik.values.sellerChestageAllowance}
                        onChange={createformik.handleChange}
                        onBlur={createformik.handleBlur}
                      />
                    </InputGroup>
                    {createformik.errors.sellerChestageAllowance &&
                      createformik.touched.sellerChestageAllowance && (
                        <div className="error text-danger">
                          {createformik.errors.sellerChestageAllowance}
                        </div>
                      )}
                  </div>

                  <div className="col-lg-2">
                    <label>Freight Charges</label>
                    <InputGroup>
                      <Form.Control
                        // disabled={isDisabled}
                        disabled={
                          isDisabled === true
                            ? true
                            : createformik.values.freightCharges > 0
                            ? false
                            : createformik.values.damageClaims > 0 ||
                              createformik.values.pils > 0 ||
                              createformik.values.sellerChestageAllowance > 0 ||
                              createformik.values.withdrawnCharges > 0
                        }
                        type="text"
                        name="freightCharges"
                        value={createformik.values.freightCharges}
                        onChange={createformik.handleChange}
                        onBlur={createformik.handleBlur}
                      ></Form.Control>
                    </InputGroup>
                    {createformik.errors.freightCharges &&
                      createformik.touched.freightCharges && (
                        <div className="error text-danger">
                          {createformik.errors.freightCharges}
                        </div>
                      )}
                  </div>
                  <div className="col-lg-2">
                    <label>SPTF Recovery</label>
                    <InputGroup>
                      <Form.Control
                        disabled={true}
                        type="number"
                        name="sptfRecover"
                        value={createformik.values.sptfRecover}
                        onChange={createformik.handleChange}
                        onBlur={createformik.handleBlur}
                      ></Form.Control>
                    </InputGroup>
                    {createformik.errors.sptfRecover &&
                      createformik.touched.sptfRecover && (
                        <div className="error text-danger">
                          {createformik.errors.sptfRecover}
                        </div>
                      )}
                  </div>
                  <div className="col-lg-2">
                    <label>Withdrawn Charges (Excluding taxes)</label>
                    <InputGroup>
                      <Form.Control
                        // disabled={isDisabled}
                        disabled={
                          isDisabled === true
                            ? true
                            : createformik.values.withdrawnCharges > 0
                            ? false
                            : createformik.values.damageClaims > 0 ||
                              createformik.values.pils > 0 ||
                              createformik.values.sellerChestageAllowance > 0 ||
                              createformik.values.freightCharges > 0
                        }
                        type="text"
                        name="withdrawnCharges"
                        value={createformik.values.withdrawnCharges}
                        onChange={createformik.handleChange}
                        onBlur={createformik.handleBlur}
                      ></Form.Control>
                    </InputGroup>
                    {createformik.errors.withdrawnCharges &&
                      createformik.touched.withdrawnCharges && (
                        <div className="error text-danger">
                          {createformik.errors.withdrawnCharges}
                        </div>
                      )}
                  </div>
                  <div className="col-lg-2">
                    <label>Remarks</label>
                    <InputGroup>
                      <Form.Control
                        disabled={isDisabled}
                        type="text"
                        name="remarks"
                        value={createformik.values.remarks}
                        onChange={createformik.handleChange}
                        onBlur={createformik.handleBlur}
                      ></Form.Control>
                    </InputGroup>
                    {createformik.errors.remarks &&
                      createformik.touched.remarks && (
                        <div className="error text-danger">
                          {createformik.errors.remarks}
                        </div>
                      )}
                  </div>
                  <div className="col-lg-2">
                    <label>Charges Entered On </label>
                    <InputGroup>
                      <Form.Control
                        disabled="true"
                        type={"text"}
                        name="enteredOn"
                        value={
                          isEdit === true || isDisabled === true
                            ? createformik.values.enteredOn
                            : dd +
                              "-" +
                              mm +
                              "-" +
                              yy +
                              " " +
                              `${hh}:${min}:${sec} ${ampm}`
                        }
                        onChange={createformik.handleChange}
                        onBlur={createformik.handleBlur}
                      ></Form.Control>
                    </InputGroup>
                    {createformik.errors.enteredOn &&
                      createformik.touched.enteredOn && (
                        <div className="error text-danger">
                          {createformik.errors.enteredOn}
                        </div>
                      )}
                  </div>
                  <div className="col-lg-2">
                    <label>Status</label>
                    <InputGroup>
                      <Form.Control
                        disabled="true"
                        as="select"
                        name="status"
                        value={createformik.values.status}
                        onChange={createformik.handleChange}
                        onBlur={createformik.handleBlur}
                      >
                        {isEdit === true || isDisabled === true ? (
                          <>
                            <option value={0}>All</option>
                            <option value={1}>Not Applied</option>
                            <option value={2}>Applied</option>
                          </>
                        ) : (
                          <>
                            <option value={0}>-</option>
                          </>
                        )}
                      </Form.Control>
                    </InputGroup>
                    {createformik.errors.status &&
                      createformik.touched.status && (
                        <div className="error text-danger">
                          {createformik.errors.status}
                        </div>
                      )}
                  </div>
                </div>

                <div className="BtnGroup">
                  {isDisabled === true ? (
                    ""
                  ) : isEdit === true ? (
                    <>
                      {modalRight.includes("2") && (
                        <button className="SubmitBtn" type="submit">
                          Update
                        </button>
                      )}
                    </>
                  ) : (
                    <>
                      {modalRight.includes("1") && (
                        <button type="submit" className="SubmitBtn">
                          Submit
                        </button>
                      )}
                    </>
                  )}
                </div>
              </form>
            </AccordionDetails>
          </Accordion>
        )}
        {/* panel3 */}
        {modalRight?.includes("6") && (
          <Accordion
            expanded={expandedTab === "panel3"}
            onChange={handleAccordionChange("panel3")}
            className={`${expandedTab === "panel3" ? "active" : ""}`}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3a-content"
              id="panel3a-header"
            >
              <Typography>Upload Seller Charges </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <UploadSellerChargesForm
                // invoiceResponseData={invoiceResponseData}
                isDisabled={isDisabled}
                // srNo={srNo}
                // viewData={viewData}
                handleAccordionChange={handleAccordionChange}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                modalRight={modalRight}
                expandedTab={expandedTab}
                setExpandedTab={setExpandedTab}
                setRows={setRows}
                formikhandlesubmit={() => formik.handleSubmit()}
                tableData={tableData}
                setTableData={setTableData}
              />
            </AccordionDetails>
          </Accordion>
        )}
      </div>
    </>
  );
};

export default SellerChargesModal;
